import {useEffect, useMemo} from 'react';

import {useDatadogRum} from '../../../util/datadog/datadogRum';
import {
  useStatsigGateBackendLineConstruction,
  useStatsigGateBackendLineConstructionSmoothing,
  useStatsigGateBackendLineConstructionTimeUnits,
} from '../../../util/rampFeatureFlags';

export type BackendLineConstructionFlags = {
  canUseBackendLineConstruction: boolean;
  canUseBackendLineConstructionSmoothing: boolean;
  canUseBackendLineConstructionTimeUnits: boolean;
};

export const useBackendLineConstruction = (
  entityName: string
): BackendLineConstructionFlags => {
  const ddRum = useDatadogRum();
  const canUseBackendLineConstruction =
    useStatsigGateBackendLineConstruction(entityName);
  const canUseBackendLineConstructionSmoothing =
    useStatsigGateBackendLineConstructionSmoothing(entityName);
  const canUseBackendLineConstructionTimeUnits =
    useStatsigGateBackendLineConstructionTimeUnits(entityName);

  // track
  useEffect(() => {
    ddRum.addAction('Backend Line Construction: Panel Load', {
      useBackendLineConstruction: canUseBackendLineConstruction,
      useBackendLineConstructionSmoothing:
        canUseBackendLineConstructionSmoothing,
      useBackendLineConstructionTimeUnits:
        canUseBackendLineConstructionTimeUnits,
    });
  }, [
    canUseBackendLineConstruction,
    canUseBackendLineConstructionSmoothing,
    canUseBackendLineConstructionTimeUnits,
    ddRum,
  ]);

  return useMemo(
    () => ({
      canUseBackendLineConstruction,
      canUseBackendLineConstructionSmoothing,
      canUseBackendLineConstructionTimeUnits,
    }),
    [
      canUseBackendLineConstruction,
      canUseBackendLineConstructionSmoothing,
      canUseBackendLineConstructionTimeUnits,
    ]
  );
};
